import { Articles } from "../../data/models/article";

export const BlogComponent = ({
  blog,
  onClick,
}: {
  blog: Articles;
  onClick: () => void;
}) => {
  if (!blog) {
    return (
      <div className="flex h-[300px] animate-pulse flex-col gap-[16px] rounded-[42px] bg-gray-700"></div>
    );
  }
  return (
    <div onClick={onClick} className="flex cursor-pointer flex-col gap-[16px]">
      <img
        src={`${process.env.REACT_APP_STRAPI_URL}${blog.cover?.formats.large.url}`}
        alt={blog.title}
        className="w-full max-w-full rounded-[42px]"
      />
      <div className="flex flex-col gap-[8px]">
        <p className="font-inter text-[24px] font-medium leading-[100%] tracking-[-0.01em] text-[#FFFEFD] lg:text-[38px] lg:tracking-[-0.02em]">
          {blog.title}
        </p>
        <p className="font-inter text-[16px] font-normal leading-[140%] tracking-[0%] text-[#5A5A59] lg:text-[#D2D2D2]">
          {blog.author}
        </p>
      </div>
    </div>
  );
};
